import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-yes-no-dialog',
  templateUrl: './active-hours-dialog.component.html',
  styleUrls: ['./active-hours-dialog.component.scss']
})
export class ActiveHoursDialogComponent {


  constructor(
    private dialogRef: MatDialogRef<ActiveHoursDialogComponent>,
  ) { }


  submit() {
    this.dialogRef.close(true)
  }
}
